module.exports = __webpack_public_path__ + "static/media/m1.74098bb4.PNG";